import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  selectWeek, selectDate,
  selectCinema, openModal,
  closeModal,
  getCurrentTime, getFilmDetails,
  getWeeksAndCinemas,
} from 'actions/appActions';
import PurchaseModal from 'components/PurchaseModal/PurchaseModal';
import CinemaFilter from 'components/Filters/CinemaFilter';
import WeekFilter from 'components/Filters/WeekFilter';
import DayFilter from 'components/Filters/DayFilter';


class AppFilter extends React.Component {
  state = {
    initialised: false,
  };

  componentDidMount() {
    this.props.dispatchGetFilmDetails(this.props.movieId);
    this.props.dispatchGetWeeksAndCinemas();
    this.props.dispatchGetCurrentTime();
  }

  bodyOnClick = (dispatchCloseModal) => {
    if (!this.state.initialised) {
      document.documentElement.addEventListener('click', (event) => {
        const pathes = event.path || (event.composedPath && event.composedPath());
        if (!pathes.some(path => (path.classList
          ? path.classList.contains('react-purchase-content') || path.classList.contains('react-purchase-modal-container')
          : false),
        )) {
          dispatchCloseModal();
        }
      });
      this.setState({ initialised: true });
    }
  }

  selectWeek = (week) => {
    this.props.dispatchSelectWeek(week);
  }

  render() {
    const {
      dates, weeks, selectedDate, selectedWeek,
      selectedCinema, dispatchSelectDate,
      dispatchSelectCinema, schedule,
      cinemas, width, dispatchOpenModal,
      dispatchCloseModal, activeModal,
      currentTime, brandClass,
      loading,
    } = this.props;
    this.bodyOnClick(dispatchCloseModal);
    return (
      <React.Fragment>
        {
          loading || cinemas !== null
            ? (
              <div className="react-filter-title-container">
                <div className={`react-mozi-brand ${brandClass} react-filter-title`}>Mikor vetítik?</div>
                <div className={`react-mozi-brand ${brandClass} react-filter-subtitle`}>
                  A jegyvásárláshoz kattintson az időpontra! Kérjük, ellenőrizze, hogy a megfelelő mozi van-e kiválasztva!
                </div>
              </div>
            )
            : <div className={`react-mozi-brand ${brandClass} react-filter-title`}></div>
        }
        {
          cinemas !== null
            ? (
              <React.Fragment>
                <div className="react-filter-container">
                  <CinemaFilter
                    cinemas={cinemas}
                    selectedCinema={selectedCinema}
                    selectCinema={(cinema) => { dispatchSelectCinema(cinema); }}
                    brandClass={brandClass}
                  />
                  <WeekFilter
                    selectedWeek={selectedWeek}
                    onClick={this.selectWeek}
                    weeks={weeks}
                    brandClass={brandClass}
                  />
                  <DayFilter
                    selectedDate={selectedDate}
                    onClick={(date) => { dispatchSelectDate(date); }}
                    dates={dates}
                    brandClass={brandClass}
                  />
                  {currentTime !== null
                    ? (
                      <div className="react-purchase-real-container">
                        {schedule.length > 0
                          ? schedule.map((date, index) => (
                            date.cinemas.length > 0
                              ? (
                                <PurchaseModal
                                  {...date}
                                  key={index.toString()}
                                  width={width}
                                  color="#FFF"
                                  bColor="#231F20"
                                  tabIndex={index.toString()}
                                  handleClick={() => dispatchOpenModal({
                                    playtime: date.playtime,
                                  })}
                                  hours={currentTime.hours}
                                  minutes={currentTime.hours}
                                  selectedDate={selectedDate}
                                  active={activeModal.playtime === date.playtime}
                                  brandClass={brandClass}
                                />
                              ) : null
                          ))
                          : <div className={`react-mozi-brand ${brandClass}`}>Az alábbi szűrési feltételek alapján nem található vetítés.</div>
                        }
                      </div>
                    )
                    : null}
                </div>
              </React.Fragment>
            ) : null
        }

      </React.Fragment>
    );
  }
}

const mapStateToProps = store => ({
  dates: store.app.dates,
  weeks: store.app.weeks,
  cinemas: store.app.cinemas,
  selectedDate: store.app.selectedDate,
  selectedWeek: store.app.selectedWeek,
  selectedCinema: store.app.selectedCinema,
  searchField: store.app.searchField,
  timeList: store.app.timeList,
  realTableData: store.app.realTableData,
  weeksDetails: store.app.weeksDetails,
  activeModal: store.app.activeModal,
  currentTime: store.app.currentTime,
  schedule: store.app.filteredMovies,
  brandClass: store.app.brandClass,
  loading: store.app.loading,
});

const mapDispatchToProps = {
  dispatchSelectDate: selectDate,
  dispatchSelectWeek: selectWeek,
  dispatchSelectCinema: selectCinema,
  dispatchCloseModal: closeModal,
  dispatchGetCurrentTime: getCurrentTime,
  dispatchGetFilmDetails: getFilmDetails,
  dispatchOpenModal: openModal,
  dispatchGetWeeksAndCinemas: getWeeksAndCinemas,
};

AppFilter.propTypes = {
  loading: PropTypes.bool.isRequired,
  brandClass: PropTypes.string.isRequired,
  dispatchGetWeeksAndCinemas: PropTypes.func.isRequired,
  schedule: PropTypes.arrayOf(PropTypes.shape({})),
  selectedDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({}),
  ]).isRequired,
  selectedCinema: PropTypes.number.isRequired,
  selectedWeek: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  activeModal: PropTypes.shape({}).isRequired,
  dispatchGetCurrentTime: PropTypes.func.isRequired,
  dispatchSelectDate: PropTypes.func.isRequired,
  dispatchSelectWeek: PropTypes.func.isRequired,
  dispatchSelectCinema: PropTypes.func.isRequired,
  dispatchGetFilmDetails: PropTypes.func.isRequired,
  dispatchCloseModal: PropTypes.func.isRequired,
  dates: PropTypes.arrayOf(PropTypes.shape({})),
  weeks: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ])),
  cinemas: PropTypes.arrayOf(PropTypes.shape({})),
  currentTime: PropTypes.shape({}),
  movieId: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  dispatchOpenModal: PropTypes.func.isRequired,
};

AppFilter.defaultProps = {
  currentTime: {
    hours: new Date().getHours(),
    minutes: new Date().getMinutes(),
  },
  selectedWeek: null,
  cinemas: null,
  weeks: null,
  dates: null,
  schedule: null,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppFilter);
